import "../../../styles/screens/client-visit-details/ProfileCard.css";
import avatar from "../../../assets/user-placeholder.png";
import "../../../styles/screens/client-visit-details/SpeakerCard.css";
import edit from "../../../assets/edit.svg";
import del from "../../../assets/delete.svg";
import { useState } from "react";
import AddNewSpeakerForm from "./manage-module/AddNewSpeakerForm";
import { useDispatch } from "react-redux";
import {
  deleteSpeaker,
  updateSpeaker,
  deleteAttendee,
  updateAttendee,
} from "../../../slices/SpeakerSlice";
import { useSelector } from "react-redux";
import ConfirmationDialog from "../../common-components/ConfirmationDialog";
import { TitansOfIndustryStringLabels } from "../../../util/Strings";
import MediaPlayer from "../../common-components/MediaPlayer";

function SpeakerCard({
  data,
  readOnly = false,
  isSpeaker = true,
  onDialogOpen = () => {},
  onDialogClose = () => {},
}) {
  const dispatch = useDispatch();
  const [showForm, setShowForm] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [showMediaPlayer, setShowMediaPlayer] = useState(false);
  const isVisitCompleted = useSelector(
    (state) => state.visits.selectedVisitIsCompleted
  );
  const isSubAdmin = useSelector((state) => state.login.isSubAdmin);
  const [type, setType] = useState(null);
  const [mediaUrl, setMediaUrl] = useState(null);

  function updateSpeakerData(newData) {
    if (newData) {
      const dataWithId = { id: data._id, newData: newData };
      isSpeaker
        ? dispatch(updateSpeaker(dataWithId))
        : dispatch(updateAttendee(dataWithId));
    }
    closeEditForm();
  }

  function openEditForm() {
    setShowForm(true);
    onDialogOpen();
  }

  function closeEditForm() {
    setShowForm(false);
    onDialogClose();
  }

  function openDeleteDialog() {
    setShowDelete(true);
    onDialogOpen();
  }

  function closeDeleteDialog() {
    setShowDelete(false);
    onDialogClose();
  }

  return (
    <div className="speaker-card-container">
      <div className="profile-container">
        <div className="profile">
          <div className="profile-logo-details">
            <div className="profile-logo">
              {data.photoUrl ? (
                <img src={data.photoUrl} alt="Avatar" />
              ) : (
                <img src={avatar} alt="Avatar" />
              )}
            </div>
            <div className="profile-details">
              <div className="profile-details-name">{data.name}</div>
              <div className="profile-details-designation speaker-style">
                {data.designation === "Others" || data.designation === "Client"
                  ? data.designationOther
                  : data.designation}
              </div>
              {!isSpeaker && <div className="profile-details-role">{data.role}</div>}
              {isSpeaker && (
                <>
                  <div className="profile-details-company">{data.practice} </div>
                  <div className="profile-details-designation speaker-style">
                    {data?.email}
                  </div>
                </>
              )}
              {!isSpeaker && (
                <div className="profile-details-company">{data.region} </div>
              )}
            </div>
          </div>
          {isVisitCompleted || isSubAdmin || readOnly ? null : (
            <div className="profile-controls">
              <button className="control-style">
                <img
                  src={edit}
                  alt="edit"
                  onClick={openEditForm}
                />
              </button>
              <button>
                <img
                  src={del}
                  alt="delete"
                  onClick={openDeleteDialog}
                />
              </button>
            </div>
          )}
        </div>
      </div>
      {isSpeaker && (
        <>
          <div className="profile-description">
            <div className="profile-description-heading">
              {TitansOfIndustryStringLabels.aboutMe}
            </div>
            <div
              style={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                lineClamp: 5,
                WebkitLineClamp: 5,
                WebkitBoxOrient: "vertical",
                fontSize: 14,
                fontWeight: 400,
                color: "#818181",
              }}
            >
              {data.about}
            </div>
          </div>
          {data?.videoUrl && (
            <div className="profile-video-button">
              <button
                className="speakerButtonVideo"
                onClick={() => {
                  setShowMediaPlayer(true);
                  if (data) {
                    if (data.audio) {
                      setType("audio");
                      setMediaUrl(data.audio);
                    } else if (data.video) {
                      setType("video");
                      setMediaUrl(data.video);
                    }
                  }
                }}
              >
                {TitansOfIndustryStringLabels.viewMyVideo}
              </button>
            </div>
          )}
        </>
      )}
      <AddNewSpeakerForm
        show={showForm}
        isSpeaker={isSpeaker}
        onClickNext={updateSpeakerData}
        data={data}
      />
      <ConfirmationDialog
        show={showDelete}
        buttonName="Delete"
        onClickHandle={(flag) => {
          if (flag) {
            if (isSpeaker) {
              dispatch(deleteSpeaker(data._id));
            } else {
              dispatch(deleteAttendee(data._id));
            }
          }
          closeDeleteDialog();
        }}
        title="Delete a Collaborator"
        subTitle={`Are you sure you want to delete ${data.name} record`}
        onClose={() => {
          // Make sure the dialogClose is called if dialog closes without confirming
          closeDeleteDialog();
        }}
      />
      <MediaPlayer
        show={showMediaPlayer}
        onCloseHandle={() => setShowMediaPlayer(false)}
        title="Media"
        mediaUrl={mediaUrl}
        type={type}
      />
    </div>
  );
}

export default SpeakerCard;